module.exports = __webpack_public_path__ + "img/02-04-img-03.664c2cbf.png";